import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExport } from '@awesome.me/kit-5de77b2c02/icons/classic/solid'
import { useCallback, useEffect, useMemo } from 'react'

interface Props {
  csvData: string
  fileName?: string
  onDownloadDone?: () => void
}

const ExportButton = ({
  csvData,
  onDownloadDone,
  fileName = 'export.csv'
}: Props) => {
  const url = useMemo(() => {
    const blob = new Blob([csvData], { type: 'text/csv' })
    return URL.createObjectURL(blob)
  }, [csvData])

  const onClickBtn = useCallback(() => {
    onDownloadDone && onDownloadDone()
  }, [onDownloadDone])
  useEffect(
    () => () => {
      url && URL.revokeObjectURL(url)
    },
    [url]
  )

  return (
    <a href={url} download={fileName} onClick={onClickBtn}>
      <FontAwesomeIcon icon={faFileExport} />
      Click to download your file
    </a>
  )
}

export default ExportButton
